import { FormattedMessage, useIntl } from 'react-intl';

import Money from '@/components/Money';
import { ChartTooltipFormatedDate } from '@/features/dashboard/components/ChartTooltipFormatedDate';
import type { TooltipProps } from '@/features/dashboard/types';
import { formatEnergyValue } from '@/lib/utils';
import { useUserStore } from '@/stores/userStore';

export const ChartTooltipContent = (props: TooltipProps) => {
    const { active, payload } = props;
    const { currency } = useUserStore();
    const { locale } = useIntl();

    if (!active || !payload?.length) {
        return null;
    }

    const { energy, costs, sessions: sessionCount } = payload[0].payload;

    const { value: energyValue, unit: energyUnit } = formatEnergyValue(energy ?? 0, locale);

    return (
        <div className='panel display-flex width-100pct flex-column padding-10'>
            <span className='border border-bottom-only border-width-2 padding-bottom-5'>
                <ChartTooltipFormatedDate
                    payload={payload}
                    dateFormat={props.dateFormat}
                    timeFrame={props.timeFrame}
                    isClusteredByMonth={props.isClusteredByMonth}
                />
            </span>
            <span className='padding-top-5 text-color-primary'>
                <FormattedMessage id='general.totalChargingCostsNet' />:{' '}
                <strong>
                    <Money currency={currency} data-testid='money-component' value={costs ?? 0} />
                </strong>
            </span>
            <span className='text-color-black'>
                <FormattedMessage id='general.energyCharged' />:{' '}
                <strong>
                    {energyValue}
                    <span className='text-size-12'> {energyUnit}</span>
                </strong>
            </span>
            <span>
                <FormattedMessage id='general.subNavigation.chargingSessions' />: <strong>{sessionCount}</strong>
            </span>
        </div>
    );
};
